import React from "react";
import "./photoCheck.scss";
import trueIcon from "../../../images/frames/green-check-icon.svg";
import falseIcon from "../../../images/frames/red-check-icon.svg";

const PhotoCheck = ({ isChecked, setIsChecked }) => {
    return (
        <div className="photo-check">
            <div className="photo-check__item">
                <div className="photo-check__item-checkbox" onClick={() => setIsChecked(true)}>
                    {isChecked && <div className="photo-check__item-checkbox-dot"></div>}
                </div>
                <div className="photo-check__item-icon">
                    <img src={trueIcon} alt="true" className="photo-check__item-icon-img" />
                </div>
            </div>
            <div className="photo-check__item">
                <div className="photo-check__item-checkbox" onClick={() => setIsChecked(false)}>
                    {!isChecked && <div className="photo-check__item-checkbox-dot"></div>}
                </div>
                <div className="photo-check__item-icon">
                    <img src={falseIcon} alt="false" className="photo-check__item-icon-img" />
                </div>
            </div>
        </div>
    );
};

export default PhotoCheck;
